import { Attrs, EventListeners, MinzeElement } from 'minze'
import { Locale } from '../../modules/locale'
import MainModule from '../../modules/main'

Locale.getInstance().registerKeySet('fr', 'lvcGoogleMaps', {
  label: "M'y rendre",
})
Locale.getInstance().registerKeySet('en', 'lvcGoogleMaps', {
  label: 'Getting there',
})

export interface LvcGoogleMaps {
  locationString?: string
  dataComponentLocation: string
  placeName?: string
  eventName?: string
}
export class LvcGoogleMaps extends MinzeElement {
  attrs: Attrs = ['location-string', 'data-component-location', 'place-name', 'event-name']
  handleClick = async (event: Event) => {
    event.preventDefault()
    try {
      const mainModule = MainModule.getInstance()
      await mainModule.analyticsTrack('lieu_m_y_rendre', {
        nom: this.eventName || this.placeName || '',
        emplacement: this.dataComponentLocation || '',
      })
    } catch (error) {
      console.error('Error tracking analytics:', error)
    }
    if (!this.locationString) {
      console.warn('No location provided for Google Maps link')
      return
    }
    const href = `https://www.google.com/maps/search/?api=1&query=${this.locationString}&hl=${Locale.language}`
    window.open(href)
  }
  html = () => `
    <a href="https://www.google.com/maps/search/?api=1&query=${this.locationString}&hl=${Locale.language}" target="_blank">
      ${mapsIcon}
      <div class="label">${Locale.getKey('lvcGoogleMaps.label')}</div>
    </a>
  `
  css = () => `
    :host {
      display: inline-flex;
      min-height: 35px;
      border-radius: 999px;
      background: linear-gradient(100deg, #FFFFFF 5%, #BFF0FF 148.15%);
      background-size: 300%;
      font-size: 12px;
      font-family: inherit;
      pointer-events: ${this.isFree ? 'none' : 'auto'};
      cursor: ${this.isFree ? 'auto' : 'pointer'};
      transition: background 0.2s ease;
    }
    :host(:hover) {
      background-size: 100%;
    }
    .label {
      text-wrap: nowrap;
      margin-right: 10px;
    }
    a {
      justify-content: center;
      align-items: center;
      min-height: 35px;
      padding: 0 16px;
      display: flex;
      gap: 4px;
      text-decoration: none;
      color: #1E007D;
      align-items: center;
    }
  `
  eventListeners: EventListeners = [[this, 'click', this.handleClick]]
}

const mapsIcon = `
<svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1480_7787)">
<path d="M7.04831 12.7972C7.3698 16.7596 11.0232 21.6408 13.3773 24.2267C13.7801 24.6692 14.4773 24.6315 14.8575 24.1695C17.285 21.2188 21.3848 16.377 21.0923 12.7725C20.6879 7.78885 17.3849 4.71256 14.3514 4.95869C11.3178 5.20482 6.59902 7.25984 7.04831 12.7972Z" stroke="#FF4600" stroke-width="1.35"/>
<path d="M13.5741 9.07796C15.0776 8.98359 16.25 10.245 16.25 11.684C16.25 13.123 15.1614 14 13.7943 14C12.4272 14 11.25 13.0213 11.25 11.5824C11.25 10.2933 12.1611 9.20906 13.3292 9" stroke="#FF4600" stroke-width="1.35" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_1480_7787">
<rect width="28" height="28" fill="white" transform="translate(0.25)"/>
</clipPath>
</defs>
</svg>

`
